import { render, staticRenderFns } from "./drill_out_former.vue?vue&type=template&id=40c10c8a&"
import script from "./drill_out_former.vue?vue&type=script&lang=js&"
export * from "./drill_out_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports